import { Divider as PrimeReactDivider } from "primereact/divider";

export default function Divider() {
    return (
        <PrimeReactDivider className="mt-3 mb-3 w-full" layout="horizontal"></PrimeReactDivider>
    )
}
